import { lazy } from '@/service/lazy'

export default [{
  name: 'Promotoras',
  path: 'empresas',
  id: 'empresas',
  icon: 'fa fa-building-o',
  component: lazy('app/default/gerenciador/empresa/index'),
  meta: { requireAuth: true, rules: ['gerenciar_empresa'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/empresa.js